import React, { useState, useEffect, useCallback, useRef } from "react";
import './ProfileCard.css';
import Card from './Card/card';
import Carousel from './Carousel/Carousel';
import Footer from './Footer/Footer';
import Header from "./Header/header";

//Images
import holeIsMine from '../images/holeismine.jpg'
import holeIsMineHover from '../images/holeismineHover.gif'
import astro from '../images/astro.png'
import astroHover from '../images/astroHover.gif'
import stick from '../images/stick.png'
import stickHover from '../images/stickHover.jpg'
import BTM from '../images/BTM.png'
import BTMHover from '../images/BTMHover.jpg'
import Raver from '../images/raver.png'
import RaverHover from '../images/raverHover.png'
import GroundBreaker from '../images/groundbreaker.png'
import GroundBreakerHover from '../images/groundbreakerHover.png'
import Chess from '../images/chess.png'
import ChessHover from '../images/chessHover.jpg'
import Randomify from '../images/randomify.png'
import RandomifyHover from '../images/randomifyHover.png'
import BodyCombat from '../images/bodycombat.jpg'
import BodyCombatHover from '../images/bodycombatHover.jpg'
import StickJam from '../images/stickJam.png'
import StickJamHover from '../images/stickJamHover.png'
import Clickaxe from '../images/clickaxe.png'
import ClickaxeHover from '../images/clickaxeHover.jpg'
import FinIce from '../images/fin-ice.png'
import FinIceHover from '../images/fin-iceHover.png'
import Gyro from '../images/gyro.png'
import GyroHover from '../images/gyroHover.png'
import Nino from '../images/nino.png'
import NinoHover from '../images/ninoHover.png'
import Slump from '../images/slump.png'
import SlumpHover from '../images/slumpHover.png'
import Magolf from '../images/magolf.png'
import MagolfHover from '../images/magolfHover.png'
import Life from '../images/life.png'
import LifeHover from '../images/lifeHover.png'
import Odders from '../images/odders.png'
import OddersHover from '../images/oddersHover.png'
import SGD from '../images/sgd.png'
import SGDHover from '../images/sgdHover.png'
import BTGCover from '../images/BTGCover.jpg'
import BTGHover from '../images/BTGHover.jpg'
import DestripandoAstro from '../images/destripandoastro.png'
import DestripandoAstroHover from '../images/destripandoastroHover.png'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRss } from '@fortawesome/free-solid-svg-icons'
import incrementalistLogo from '../images/incrementalistLogo.png'
import spainGameDevsLogo from '../images/SpainGameDevsLogo.png'
import ProfileClickEgg from './EasterEgg/ProfileClickEgg'
import AchievementToasts from './EasterEgg/AchievementToasts'
import { ACHIEVEMENTS } from './EasterEgg/achievements'
import AboutView from './About/AboutView'

const ITEMS = {
    hole_is_mine: {
        image: holeIsMine, hoverImage: holeIsMineHover,
        description: "Incremental mining adventure about purifying a divine Hole.",
        title: "Hole Is Mine",
        links: [
            { platform: 'steam', url: 'https://store.steampowered.com/app/4508020/Hole_Is_Mine/' },
            { platform: 'itch', url: 'https://incrementalist-games.itch.io/hole-is-mine' },
        ]
    },
    astro: {
        image: astro, hoverImage: astroHover,
        description: "Incremental bullet hell about mining coffee and fighting SpaceCorp.",
        title: "Astro Prospector",
        links: [
            { platform: 'steam', url: 'https://store.steampowered.com/app/3503440/Astro_Prospector/' },
        ]
    },
    stick: {
        image: stick, hoverImage: stickHover,
        description: "A cute puzzle game about a dog who loves looong sticks.",
        title: "Stick to the Plan",
        links: [
            { platform: 'steam', url: 'https://store.steampowered.com/app/2334280/Stick_to_the_Plan/' },
            { platform: 'switch', url: 'https://www.nintendo.com/us/store/products/stick-to-the-plan-switch/' },
        ]
    },
    btm: {
        image: BTM, hoverImage: BTMHover,
        description: "Graphic (mis)adventure about a boy who becomes giant when hearing the word 'FUTURE'.",
        title: "Bigger Than Me",
        links: [
            { platform: 'steam', url: 'https://store.steampowered.com/app/1882690/Bigger_Than_Me/' },
            { platform: 'itch', url: 'https://deadpixeltales.itch.io/bigger-than-me' },
        ]
    },
    raver: {
        image: Raver, hoverImage: RaverHover,
        description: `Short narrative videogame made to commission for Brainwash Gang, starring a character from their game "Friends VS Friends".`,
        title: "Raver's Rumble",
        links: [
            { platform: 'itch', url: 'https://deadpixeltales.itch.io/ravers-rumble' },
        ]
    },
    randomify: {
        image: Randomify, hoverImage: RandomifyHover,
        description: "A blazingly fast and easy-to-use weighted randomizer for Unity.",
        title: "Randomify",
        links: [
            { platform: 'unity', url: 'https://assetstore.unity.com/packages/templates/systems/randomify-fast-easy-weighted-randomizer-174978' },
        ]
    },
    chess: {
        image: Chess, hoverImage: ChessHover,
        description: "The classic Chess game on Virtual Reality. Including multiplayer!",
        title: "Chess Club",
        links: [
            { platform: 'quest', url: 'https://www.oculus.com/experiences/quest/5353996901307344/' },
            { platform: 'pico', url: 'https://www.picoxr.com/global/games/chess-club' },
        ]
    },
    bodyCombat: {
        image: BodyCombat, hoverImage: BodyCombatHover,
        description: "A fitness VR game based on Les Mills Bodycombat. I worked on the HTC porting.",
        title: "Les Mills Body Combat VR",
        links: [
            { platform: 'quest', url: 'https://www.oculus.com/experiences/quest/5353996901307344/' },
            { platform: 'pico', url: 'https://www.picoxr.com/global/games/les-mills-bodycombat' },
        ]
    },
    clickaxe: {
        image: Clickaxe, hoverImage: ClickaxeHover,
        description: "A clicker roguelite! The Sun has been stolen. The night has come.",
        title: "Clickaxe",
        links: [
            { platform: 'itch', url: 'https://delunado.itch.io/clickaxe' },
        ]
    },
    stickJam: {
        image: StickJam, hoverImage: StickJamHover,
        description: "A cute puzzle game about a dog who loves looong sticks. Jam version.",
        title: "Stick to the plan [JAM]",
        links: [
            { platform: 'itch', url: 'https://deadpixeltales.itch.io/stick-to-the-plan-jam' },
        ]
    },
    gyro: {
        image: Gyro, hoverImage: GyroHover,
        description: "Physics-based puzzle game where you control the map, not the player!",
        title: "Gyroglyph",
        links: [
            { platform: 'itch', url: 'https://delunado.itch.io/gyroglyph' },
        ]
    },
    magolf: {
        image: Magolf, hoverImage: MagolfHover,
        description: "Magic & Golf in the guts of a colossus.",
        title: "Magolf",
        links: [
            { platform: 'itch', url: 'https://delunado.itch.io/magolf' },
        ]
    },
    groundBreaker: {
        image: GroundBreaker, hoverImage: GroundBreakerHover,
        description: "GroundBreaker is an incremental roguelite experience where you have to reach the end of a dark mine.",
        title: "GroundBreaker",
        links: [
            { platform: 'itch', url: 'https://delunado.itch.io/groundbreaker' },
        ]
    },
    nino: {
        image: Nino, hoverImage: NinoHover,
        description: "Turn-Based Twin-Stick Shooter where Nino must look for his grandfather.",
        title: "Nino, your grandpa is nuts!",
        links: [
            { platform: 'itch', url: 'https://eufrasi0.itch.io/nino' },
        ]
    },
    finIce: {
        image: FinIce, hoverImage: FinIceHover,
        description: "2-Players Local Competitive Game about Tag and Penguins!",
        title: "Fin Ice",
        links: [
            { platform: 'itch', url: 'https://delunado.itch.io/fin-ice' },
        ]
    },
    life: {
        image: Life, hoverImage: LifeHover,
        description: "Open-Source Sandbox Simulation made in Unity.",
        title: "Life in a Box",
        links: [
            { platform: 'itch', url: 'https://delunado.itch.io/life-in-a-box' },
        ]
    },
    slump: {
        image: Slump, hoverImage: SlumpHover,
        description: "This little slime from outer space is just having a relaxing day jumping and having some fun!",
        title: "Slump!",
        links: [
            { platform: 'itch', url: 'https://delunado.itch.io/slump' },
        ]
    },
    talk_btg: {
        image: BTGCover, hoverImage: BTGHover,
        description: "An interview where I talk about how to start making games & my experience in the industry. (Spanish)",
        title: "El Efecto Mariposa",
        links: [
            { platform: 'youtube', url: 'https://www.youtube.com/watch?v=-405PVKOGXY&t=2849s' },
        ]
    },
    talk_odders: {
        image: Odders, hoverImage: OddersHover,
        description: "A talk about my experience jumping from 2D indie games to VR industry. (Spanish)",
        title: "Saltando entre dimensiones: 2D a VR",
        links: [
            { platform: 'youtube', url: 'https://www.youtube.com/watch?v=uHDHh5ad1LA' },
        ]
    },
    talk_sgd: {
        image: SGD, hoverImage: SGDHover,
        description: "Around 18 talks about different parts of game development from both new and veterans from spanish gamedev industry. (Spanish)",
        title: "Spain Game Devs Talks",
        links: [
            { platform: 'youtube', url: 'https://www.youtube.com/@SpainGameDevs/videos' },
        ]
    },
    talk_destripando_astro: {
        image: DestripandoAstro, hoverImage: DestripandoAstroHover,
        description: "A technical & team deep-dive into the development of Astro Prospector (Spanish)",
        title: "Destripando Astro Prospector",
        links: [
            { platform: 'youtube', url: 'https://www.youtube.com/watch?v=GfA0QL_PUxw' },
        ]
    },
};

const WorkedOnData = [
    ITEMS.hole_is_mine,
    ITEMS.astro,
    ITEMS.stick,
    ITEMS.btm,
    ITEMS.raver,
    ITEMS.randomify,
    ITEMS.chess,
    ITEMS.bodyCombat
];

const GameJamData = [
    ITEMS.clickaxe,
    ITEMS.stickJam,
    ITEMS.gyro,
    ITEMS.magolf,
    ITEMS.groundBreaker,
    ITEMS.nino,
    ITEMS.finIce,
    ITEMS.life,
    ITEMS.slump
];

const TalksAndWorkshops = [
    ITEMS.talk_btg,
    ITEMS.talk_odders,
    ITEMS.talk_sgd,
    ITEMS.talk_destripando_astro
];

const AllData = [...WorkedOnData, ...GameJamData, ...TalksAndWorkshops];

const MOBILE_MQ = '(max-width: 600px)';
const NON_COMPLETIONIST_IDS = Object.keys(ACHIEVEMENTS).filter(id => id !== 'COMPLETIONIST');

const ProfileCard = () => {
    const [currentView, setCurrentView] = useState('projects');
    const [carouselPage, setCarouselPage] = useState(0);
    const [achievements, setAchievements] = useState([]);
    const [totalAchievements, setTotalAchievements] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(
        () => window.matchMedia(MOBILE_MQ).matches ? 1 : 3
    );
    const unlockedIdsRef = useRef(new Set());
    const visitedPagesRef = useRef(new Set([0]));

    useEffect(() => {
        const mq = window.matchMedia(MOBILE_MQ);
        const handler = (e) => {
            setItemsPerPage(e.matches ? 1 : 3);
            visitedPagesRef.current = new Set([0]);
        };
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);

    const totalPages = Math.ceil(AllData.length / itemsPerPage);
    const jamsNavPage = Math.floor(WorkedOnData.length / itemsPerPage);
    const talksNavPage = Math.ceil((WorkedOnData.length + GameJamData.length) / itemsPerPage);

    const getSectionFromPage = (page) => {
        if (itemsPerPage === 1) {
            if (page >= WorkedOnData.length + GameJamData.length) return 'Talks';
            if (page >= WorkedOnData.length) return 'Game Jams';
            return 'Games';
        }
        if (page >= 5) return 'Talks';
        if (page >= 3) return 'Game Jams';
        return 'Games';
    };

    const unlockAchievement = useCallback((id) => {
        if (unlockedIdsRef.current.has(id)) return;
        unlockedIdsRef.current.add(id);
        setTotalAchievements(n => n + 1);
        setAchievements(prev => [...prev, ACHIEVEMENTS[id]]);
    }, []);

    const closeAchievement = useCallback((id) => {
        setAchievements(prev => prev.filter(a => a.id !== id));
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => unlockAchievement('IDLE_WATCHER'), 60000);
        return () => clearTimeout(timer);
    }, [unlockAchievement]);

    useEffect(() => {
        visitedPagesRef.current.add(carouselPage);
        if (visitedPagesRef.current.size >= totalPages) {
            unlockAchievement('CAROUSEL_TRAVELER');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carouselPage, unlockAchievement]);

    useEffect(() => {
        if (NON_COMPLETIONIST_IDS.every(id => unlockedIdsRef.current.has(id))) {
            unlockAchievement('COMPLETIONIST');
        }
    }, [totalAchievements, unlockAchievement]);

    const activeSection = getSectionFromPage(carouselPage);

    const handleNavClick = (page) => {
        setCarouselPage(page);
    };

    const handleRandom = () => {
        setCarouselPage(Math.floor(Math.random() * totalPages));
    };

    return (
        <div className="profile-card">
            <div className="profile-header">
                <div className="main-profile">
                    <ProfileClickEgg onUnlock={() => unlockAchievement('AVATAR_LEGEND')} />
                    <div className="profile-names">
                        <div className="profile-names__title">
                            <h1 className="username">Javier</h1>
                            <h2>'Delunado'</h2>
                        </div>
                        <small className="page-title">Human Game Developer</small>
                    </div>
                    <div className="view-toggle">
                        <button
                            className={`view-toggle__btn${currentView === 'projects' ? ' view-toggle__btn--active' : ''}`}
                            onClick={() => setCurrentView('projects')}
                        >
                            Projects
                        </button>
                        <button
                            className={`view-toggle__btn${currentView === 'about' ? ' view-toggle__btn--active' : ''}`}
                            onClick={() => { setCurrentView('about'); unlockAchievement('ABOUT_VISITOR'); }}
                        >
                            About
                        </button>
                        <a
                            className="view-toggle__btn view-toggle__btn--blog"
                            href="https://www.delunado.com/blog"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Blog
                        </a>
                    </div>
                </div>
                {totalAchievements > 0 && (
                    <span className="achievement-count-badge" key={totalAchievements}>
                        🎖️ {totalAchievements}
                    </span>
                )}
            </div>
            {currentView === 'projects' && (
                <>
                    <div className="main-content">
                        <div className="about-section">
                            <a className="about-section__fact" href='https://store.steampowered.com/app/3503440/Astro_Prospector/' target="_blank" rel="noopener noreferrer" onClick={() => unlockAchievement('LINK_EXPLORER')}>
                                <img className="about-section__icon" src={incrementalistLogo} alt="Incrementalist" />
                                <span>Co-founder, Programmer and much more at <b>Incrementalist</b></span>
                            </a>

                            <a className="about-section__fact" href='https://t.me/spaingamedevs' target="_blank" rel="noopener noreferrer" onClick={() => unlockAchievement('LINK_EXPLORER')}>
                                <img className="about-section__icon about-section__icon--large" src={spainGameDevsLogo} alt="Spain Game Devs" />
                                <span>Founder & Game Jam Organizer at <b>Spain Game Devs</b></span>
                            </a>
                        </div>
                    </div>
                    <div className="carousel-section">
                        <Carousel
                            items={AllData}
                            currentPage={carouselPage}
                            onPageChange={setCarouselPage}
                            onArrowClick={() => unlockAchievement('ARROW_CLICKER')}
                            onCardClick={() => unlockAchievement('GAME_CLICKER')}
                        />
                    </div>
                    <div className="nav-section">
                        <Header
                            activeSection={activeSection}
                            onNavClick={handleNavClick}
                            onRandom={handleRandom}
                            jamsPage={jamsNavPage}
                            talksPage={talksNavPage}
                        />
                    </div>
                </>
            )}
            {currentView === 'about' && <AboutView onDogClick={() => unlockAchievement('DOG_CLICKER')} />}
            <Footer onContactClick={() => unlockAchievement('CONTACT_CLICKER')} />
            <AchievementToasts achievements={achievements} onClose={closeAchievement} />
        </div>
    );
}

export default ProfileCard;
